import { IAmendment } from '../../contracts/amendment.contract';

const getDateString = (amendmentItem: IAmendment[]): string => {
    // RPW-11: Check if GT is 0, if so, don't include GT condition
    const shouldIncludeGT = amendmentItem[0].GrossTonnage.LowerBound?.Value && amendmentItem[0].GrossTonnage.LowerBound.Value !== '0';

    let gtString: string = '';

    if (shouldIncludeGT) {
        gtString = amendmentItem[0].GrossTonnage.Value
            ? amendmentItem[0].GrossTonnage && amendmentItem[0].GrossTonnage.LowerBound
                ? `GT ${amendmentItem[0].GrossTonnage.LowerBound.InclusiveExclusive == 'INCLUSIVE' ? '>=' : '>'} ${amendmentItem[0].GrossTonnage.LowerBound.Value} and a `
                : ''
            : '';

        if (amendmentItem[0].GrossTonnage.UpperBound.Value) {
            const upperBoundString: string = `${amendmentItem[0].GrossTonnage.UpperBound.Value} ${amendmentItem[0].GrossTonnage.UpperBound.InclusiveExclusive == 'INCLUSIVE' ? '>=' : '>'}  `;
            gtString = upperBoundString + gtString;
        }
    }

    const complianceDateTypeMap: Record<string, string> = {
        CONTRACT: 'contract',
        KEEL_LAY: 'keel lay',
        DELIVERY: 'delivery'
    };
    const complianceDateOrder = ['CONTRACT', 'KEEL_LAY', 'DELIVERY'];

    const sortedAmendmentItem = amendmentItem.sort((a, b) => {
        const aIndex = complianceDateOrder.indexOf(a.ComplianceDateType);
        const bIndex = complianceDateOrder.indexOf(b.ComplianceDateType);
        return aIndex - bIndex;
    });

    // RPW-12: Filter out placeholder / empty / invalid ship age dates.
    // Tracker API returns formatted values (01-Jan-1900 / Invalid date format);
    // Vessel & Calendar APIs return raw DB values (01/01/1900 or empty).
    const isInvalidShipAgeDate = (shipAgeDate?: string | null) => {
        const value = shipAgeDate?.trim() ?? '';
        return value === '' || value === '01-Jan-1900' || value === '01/01/1900' || value === 'Invalid date format';
    };

    const filteredAmendmentItem = sortedAmendmentItem.filter((item) => !isInvalidShipAgeDate(item.ShipAgeDate));

    const vesselTest = new Map<string, string>();
    filteredAmendmentItem.map((item) => {
        return vesselTest.set(item.ComplianceDateType, item.ShipAgeDate);
    });

    const vesselDateType = Array.from(vesselTest.keys()).map((item) => (item ? `${complianceDateTypeMap[item]}` : ' '));
    const vesselDateShipAgeDate = Array.from(vesselTest.values());

    const vesselDateModifiers = filteredAmendmentItem.map((item) => (item.AgeModifier === 'before' ? 'before' : 'on or after'));

    // If no date conditions remain after filtering, return only GT string or empty
    if (vesselDateType.length === 0) {
        // Remove "and a " from the end of gtString if it exists
        return gtString.replace(/ and a $/, '').trim();
    }

    if (vesselDateType.length === 1) {
        return `${gtString}${vesselDateType[0]} date ${vesselDateModifiers[0]} ${vesselDateShipAgeDate[0]}`;
    }

    if (vesselDateType.length === 2) {
        return `${gtString} ${vesselDateType[0]} date ${vesselDateModifiers[0]} ${vesselDateShipAgeDate[0]} or ${vesselDateType[1]} date ${vesselDateModifiers[1]} ${vesselDateShipAgeDate[1]}`;
    }

    if (vesselDateType.length === 3) {
        return `${gtString} ${vesselDateType[0]} date ${vesselDateModifiers[0]} ${vesselDateShipAgeDate[0]}, or ${vesselDateType[1]} date ${vesselDateModifiers[1]} ${vesselDateShipAgeDate[1]}, or ${vesselDateType[2]} date  ${vesselDateModifiers[2]} ${vesselDateShipAgeDate[2]}`;
    }

    return '';
};

export default getDateString;
